const getters = {
  // rightBtn: state => state.tabs.rightBtn,
  menuActive: state => state.home.menuActive
}
export default getters